import React, {Fragment, useContext} from 'react';
import './OrderTypeSelect.less';
import {NavigationItem} from '../navigation-item/NavigationItem';
import PickupIcon from 'new-images/pickup.svg';
import DeliveryIcon from 'new-images/delivery.svg';
import TableIcon from 'new-images/table.svg';
import {OrderingTypes} from "new-constants/common.constants";
import {IconBadgeColors} from "elements/icon-badge/IconBadge";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {ListItem} from "elements/list-item/ListItem";
import {List} from "elements/list/List";

const OrderingTypeIcons = {
	[OrderingTypes.pickup]: PickupIcon,
	[OrderingTypes.delivery]: DeliveryIcon,
	[OrderingTypes.dineIn]: TableIcon
}

const OrderingTypeNames = {
	[OrderingTypes.pickup]: "OrderTypeSelect.pickupLabel",
	[OrderingTypes.delivery]: "OrderTypeSelect.deliveryLabel",
	[OrderingTypes.dineIn]: "OrderTypeSelect.dineinLabel"
}

export const OrderTypeSelect = ({availableOrderingTypes = [], onOrderingTypeClick, isLargeScreenOnly}) => {

	const translations = useContext(TranslationsContext);

	return (
		<List isModal>
			{
				availableOrderingTypes.map((orderingType, index) => {
					return <Fragment key={orderingType}>
						<ListItem onClick={() => onOrderingTypeClick(orderingType)} isResponsive>
							<NavigationItem
								icon={OrderingTypeIcons[orderingType]}
								name={getSafeTranslation(OrderingTypeNames[orderingType], translations)}
								isPrimary
								iconColor={IconBadgeColors.primary}
							/>
						</ListItem>
					</Fragment>
				})
			}
		</List>
	);
};
